import moment from "moment";

export const weekDatesRange = ({ week, year }: { week: number; year: number }) => {
  const weekMoment = moment().year(year).week(week);
  const startDate = weekMoment.startOf("week").format("YYYY-MM-DD");
  const endDate = weekMoment.endOf("week").format("YYYY-MM-DD");
  return { startDate, endDate };
};
